export const LOCALE_DEFAULT = 'en-BE'
export const CURRENCY_SYMBOL_DEFAULT = '€'
export const TIMEZONE = 'Europe/Brussels'
